// Vendor
import $ from 'jquery';
import validate from 'validate.js';

// Modules
import Helpers from '../helpers/util';

class Fields {
	constructor(el) {
		// Elements
		this.$el = $(el);
		this.$text = this.$el.find('.field-textarea, .field-text');
		this.$label = this.$el.find('.field-label').text().trim();
		this.$select = this.$el.find('select');
		this.$checkbox = this.$el.find('.field-checkbox-button');
		this.$checkboxAll = this.$el.find('.js-field-select-all');
		this.$radioButton = this.$el.find('.js-field-radio');
		this.$allCheckboxes = this.$el.find('.js-field-checkbox');
		this.$error = this.$el.find('.field-error');
		this.$custom_validation = el.getAttribute('data-custom-validation-message');
		this.$multiAmount = this.$el.find('.js-multi-amount');
		this.$startEndTime = this.$el.find('.js-start-end-time');

		// True/false and errors
		this.isValid = true;
		this.error = [];

		// Classes
		this.clsRequired = 'js-field-required';
		this.clsRequiredGroup = 'js-field-required-group';
		this.clsEmail = 'js-field-email';
		this.clsPhone = 'js-field-phone';
		this.clsPassword = 'js-field-password';
		this.clsPasswordSetup = 'js-field-password-setup';
		this.clsMatch = 'js-field-match';
		this.clsDate = 'js-field-date';
		this.cls24HrTime = 'js-field-24h-time';
		this.clsTemperature = 'js-field-temperature';
		this.clsAhpra = 'js-ahpra';
		this.clsError = 'has-error';
		this.clsVisible = 'is-visible';

		this.setupFields();

		this.attachEvents();
	}

	onSubmit() {
		$.each(
			this.$text,
			function (i, v) {
				let currentTarget = $(v);
				this.validateField(currentTarget);
			}.bind(this)
		);

		$.each(
			this.$select,
			function (i, v) {
				const currentTarget = v;
				const $currentTarget = $(v);
				this.validateField($currentTarget);

				if (currentTarget.value === '') {
					return false;
				}
			}.bind(this)
		);

		$.each(
			this.$checkbox,
			function (i, v) {
				const $currentTarget = $(v);
				this.validateField($currentTarget);
			}.bind(this)
		);

		$.each(
			this.$radioButton,
			function (i, v) {
				const $currentTarget = $(v);
				this.validateField($currentTarget);
			}.bind(this)
		);

		$.each(
			this.$allCheckboxes,
			function (i, v) {
				const $currentTarget = $(v);
				this.validateField($currentTarget);
			}.bind(this)
		);

		$.each(
			this.$multiAmount,
			function (i, v) {
				const $currentTarget = $(v);
				this.validateField($currentTarget);
			}.bind(this)
		);

		$.each(
			this.$startEndTime,
			function (i, v) {
				const $currentTarget = $(v);
				this.validateField($currentTarget);
			}.bind(this)
		);
	}

	setupFields() {}

	attachEvents() {
		[
			this.$text,
			this.$checkbox,
			this.$select,
			this.$radioButton,
			this.$allCheckboxes,
		].forEach(($i) => {
			$i.on('blur', (evt) => {
				let $target = $(evt.currentTarget);
				this.validateField($target);
				$i.on('change input', () => {
					this.validateField($target);
				});
			});
		});

		// Handle password onchange for validation indicator
		this.$el.find('.js-field-password-setup').on(
			'input',
			function (evt) {
				const passwordValidation = this.validatePassword(evt.target.value);

				this.$indicators = this.$el.find(
					'.field__password-validation-hint__text'
				);

				this.$digitIndicator = this.$el.find(
					'.field__password-validation-hint__text--digit'
				);
				this.$characterIndicator = this.$el.find(
					'.field__password-validation-hint__text--character'
				);
				this.$lowercaseIndicator = this.$el.find(
					'.field__password-validation-hint__text--lowercase'
				);
				this.$uppercaseIndicator = this.$el.find(
					'.field__password-validation-hint__text--uppercase'
				);

				this.$indicators.removeClass(
					'field__password-validation-hint__text--checked'
				);

				if (passwordValidation.hasDigit) {
					this.$digitIndicator.addClass(
						'field__password-validation-hint__text--checked'
					);
				}
				if (passwordValidation.hasSpecialCharacter) {
					this.$characterIndicator.addClass(
						'field__password-validation-hint__text--checked'
					);
				}
				if (passwordValidation.hasLowercase) {
					this.$lowercaseIndicator.addClass(
						'field__password-validation-hint__text--checked'
					);
				}
				if (passwordValidation.hasUppercase) {
					this.$uppercaseIndicator.addClass(
						'field__password-validation-hint__text--checked'
					);
				}
			}.bind(this)
		);

		// Handle checkboxes a differently
		this.$checkbox.on(
			'change',
			function (evt) {
				var currentTarget = $(evt.currentTarget);
				if (currentTarget.hasClass('js-field-select-all')) {
					this.selectAll(currentTarget);
				} else {
					this.select();
				}
			}.bind(this)
		);

		// Edge case: User can toggle Geolocation field
		// Error states need to be removed
		Helpers.pubsub.subscribe('AutocompleteAddress-cantFind', (i, response) => {
			if (this.$text.is($(response.element))) {
				if (!response.isHidden) {
					this.hideError();
					this.isValid = true;
				}
			}
		});

		// Show/hide password field
		const $fieldReveal = this.$el.find('.js-field-reveal');

		$fieldReveal.on('click', function () {
			const $this = $(this);
			$this.toggleClass('is-reveal');

			const $pwField = $this.parent('.field-type').find('.js-field-password');
			const type = $pwField.attr('type');

			$pwField.prop('type', type === 'text' ? 'password' : 'text');
		});

		// Add empty/not-empty classes to selects with/without values
		const $select = this.$el.find('select');
		function checkSelect() {
			const val = $select.val();
			if (val) {
				$select.removeClass('empty');
				$select.addClass('not-empty');
			} else {
				$select.addClass('empty');
				$select.removeClass('not-empty');
			}
		}
		checkSelect();
		$select.on('change', checkSelect);
	}

	// On select, hide 'Select All';
	select() {
		this.$checkboxAll.prop('checked', false);
	}

	selectAll(currentTarget) {
		var bool = currentTarget.is(':checked');
		$.each(this.$checkbox, function () {
			var checkBool = $(this).is(':checked');
			if (bool) {
				if (!checkBool) {
					$(this).prop('checked', true);
				}
			} else {
				if (checkBool) {
					$(this).prop('checked', false);
				}
			}
		});
	}

	// https://stackoverflow.com/questions/19669786/check-if-element-is-visible-in-dom
	isFieldVisible(el) {
		return el.offsetParent !== null;
	}

	validatePassword(val) {
		let passwordValidation = {
			isValid: false,
			hasDigit: false,
			hasSpecialCharacter: false,
			hasLowercase: false,
			hasUppercase: false,
		};
		this.$digitIndicator = this.$el.find(
			'.field__password-validation-hint__text--digit'
		);
		this.$characterIndicator = this.$el.find(
			'.field__password-validation-hint__text--character'
		);
		this.$lowercaseIndicator = this.$el.find(
			'.field__password-validation-hint__text--lowercase'
		);
		this.$uppercaseIndicator = this.$el.find(
			'.field__password-validation-hint__text--uppercase'
		);

		// password validation
		const passwordDigits = /^(?=.*\d).+$/;
		const passwordSpecialCharacters = /^(?=.*[!”#$%&"()*\-<.{}?[\]@^~]).+$/;
		const passwordLowercase = /^(?=.*[a-z]).+$/;
		const passwordUppercase = /^(?=.*[A-Z]).+$/;
		const passwordLength = /^.{8,}$/;

		const matchPasswordDigits = passwordDigits.test(val);
		const matchPasswordSpecialCharacters = passwordSpecialCharacters.test(val);
		const matchPasswordLowercase = passwordLowercase.test(val);
		const matchPasswordUppercase = passwordUppercase.test(val);
		const matchPasswordLength = passwordLength.test(val);

		if (matchPasswordDigits == true && this.$digitIndicator) {
			passwordValidation.hasDigit = true;
		}
		if (matchPasswordSpecialCharacters == true && this.$characterIndicator) {
			passwordValidation.hasSpecialCharacter = true;
		}
		if (matchPasswordLowercase == true && this.$lowercaseIndicator) {
			passwordValidation.hasLowercase = true;
		}
		if (matchPasswordUppercase == true && this.$uppercaseIndicator) {
			passwordValidation.hasUppercase = true;
		}

		if (
			matchPasswordDigits +
				matchPasswordSpecialCharacters +
				matchPasswordLowercase +
				matchPasswordUppercase >=
				3 &&
			matchPasswordLength === true
		) {
			passwordValidation.isValid = true;
		}
		return passwordValidation;
	}

	validateField($el) {
		let val = $el.val();
		let constraints = {};

		// If the field is hidden, don't validate
		if ($el.hasClass('js-field-radio') || $el.hasClass('js-field-checkbox')) {
			// If it's a radio or checkbox, we need to check visibility of nextSibling (indicator)
			// as the element is always hidden (for styling reasons)
			const sibling = $el[0].nextElementSibling;
			if (sibling && !this.isFieldVisible(sibling)) {
				this.hideError();
				this.isValid = true;
				return;
			}
		} else if (!this.isFieldVisible($el[0])) {
			this.hideError();
			this.isValid = true;
			return;
		}

		if ($el.hasClass(this.clsRequired)) {
			constraints['presence'] = {
				message: `"${this.$label.replace(/\*/g, '')}" cannot be empty`,
			};
		}

		if ($el.hasClass(this.clsEmail) && val) {
			constraints['email'] = {
				message: 'Please enter a valid email address',
			};
		}

		if ($el.hasClass(this.clsPhone && val)) {
			constraints['format'] = {
				pattern: /^[0,1][0-8]\d{8}$/g,
				message: 'Please enter a valid phone number.',
			};
		}

		if ($el.hasClass(this.clsAhpra) && val) {
			constraints['format'] = {
				pattern: /^(?:MED|PHA|NMW|ZZZ)\d{10}$/,
				message: 'Please enter a valid AHPRA number.',
			};
		}

		if ($el.hasClass(this.clsPasswordSetup) && val) {
			const passwordValidation = this.validatePassword(val);
			if (passwordValidation.isValid == true) {
				this.isValid = true;
			} else {
				this.$el.addClass(this.clsError);
				this.$error.addClass(this.clsVisible);
				this.$error.text(
					'Please make sure the password meets all the requirements.'
				);
				this.isValid = false;
				return;
			}
		}

		if ($el.hasClass(this.clsMatch)) {
			let mID = $el.data('match-id');
			let $match = $(`[data-match-id="${mID}"]`);
			let $compare = $match.not($el);
			if ($compare.val().length) {
				constraints['equality'] = {
					attribute: $compare.val(),
					message: 'You passwords do not match, please try again.',
					comparator: function (v1, v2, v3) {
						return v1 === v3.attribute;
					},
				};
			}
		}

		if ($el.hasClass(this.clsDate)) {
			constraints['format'] = {
				pattern: /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/,
				message: 'Please enter a valid date (dd/mm/yyyy)',
			};
		}

		if ($el.hasClass(this.cls24HrTime) && val) {
			constraints['format'] = {
				pattern: /^([0-1][0-9]|(2)[0-4])(:?)([0-5][0-9])$/,
				message: 'Please enter a 24 hour time (00:00)',
			};
		}

		if ($el.hasClass(this.clsTemperature)) {
			if (val) {
				constraints['format'] = {
					pattern: /^((\+|-)?(\d{1,})\.(\d{1})°C)$/,
					message: 'Please enter a valid temperature (e.g. +10.0°C or -10.0°C)',
				};
			}
			// Check for greater-than/less-than
			const invalidate = (msg) => {
				this.$el.addClass(this.clsError);
				this.$error.addClass(this.clsVisible);
				this.$error.text(msg);
				this.isValid = false;
			};
			const gtAttr = parseFloat($el.data('temp-gt'));
			const ltAttr = parseFloat($el.data('temp-lt'));
			const parsedValue = parseFloat(val.replace('°C'));
			if (!isNaN(parsedValue)) {
				if (!isNaN(gtAttr) && parsedValue <= gtAttr) {
					invalidate(`This field must be greater than ${gtAttr}°C`);
					return;
				}
				if (!isNaN(ltAttr) && parsedValue >= ltAttr) {
					invalidate(`This field must be less than ${ltAttr}°C`);
					return;
				}
			}
		}

		// DATA MUST BE VALIDATION
		if (this.$el.data('radio-must-be')) {
			let valid = false;
			const mustBe = this.$el.data('radio-must-be');
			const inputs = Array.from(
				this.$el[0].querySelectorAll('input[type=radio]')
			);
			inputs.forEach((input) => {
				if (input.checked && input.id === mustBe) {
					valid = true;
				}
			});
			if (!valid) {
				this.$el.addClass(this.clsError);
				this.isValid = false;
				return;
			} else {
				this.hideError();
				this.isValid = true;
			}
		}

		// Required radio validation (one)
		if ($el.hasClass('js-field-required') && $el.hasClass('js-field-radio')) {
			// Get all radios with the same 'name' attribute
			let isValid = false;
			const name = $el.attr('name');
			const selects = document.querySelectorAll(`input[name="${name}"]`);
			selects.forEach((select) => {
				if (!isValid && select.checked) {
					isValid = true;
				}
			});
			if (!isValid) {
				this.$el.addClass(this.clsError);
				this.$error.addClass(this.clsVisible);
				this.$error.text('This field is required');
				this.isValid = false;
				return;
			} else {
				this.hideError();
				this.isValid = true;
			}
		}

		// Required checkbox validation
		else if (
			$el.hasClass(this.clsRequired) &&
			$el.hasClass('field-checkbox-button')
		) {
			let checkBool = $el.is(':checked');
			if (checkBool) {
				this.hideError();
				this.isValid = true;
			} else {
				this.$el.addClass(this.clsError);
				this.$error.addClass(this.clsVisible);
				this.$error.text(
					'You need to be a registered healthcare professional to access this website'
				);
				this.isValid = false;
			}
		}

		// Required checkbox group validation
		else if (
			$el.hasClass(this.clsRequiredGroup) &&
			$el.hasClass('js-field-checkbox')
		) {
			let isValid = false;
			let groupName = $el[0].getAttribute('data-checkbox-group') || '';
			if (groupName) {
				let checkboxesInGroup = document.querySelectorAll(
					`input[data-checkbox-group="${groupName}"]`
				);
				checkboxesInGroup.forEach((checkbox) => {
					if (!isValid && checkbox.checked) {
						isValid = true;
					}
				});
				if (!isValid) {
					this.$el.addClass(this.clsError);
					this.$error.addClass(this.clsVisible);
					this.$error.text(
						this.$custom_validation || 'You must select at least 1'
					);
					this.isValid = false;
					return;
				} else {
					this.hideError();
					this.isValid = true;
				}
			}
		} else if ($el.hasClass('js-multi-amount')) {
			const $inputs = $el.find('select');
			let multiValue = 0;

			$.each(
				$inputs,
				function (i, v) {
					multiValue = multiValue + Number(v.value);
				}.bind(this)
			);

			if (!multiValue) {
				this.isValid = false;
				this.$el.addClass(this.clsError);

				this.$error.addClass(this.clsVisible);
				this.$error.text(`"${this.$label.replace(/\*/g, '')}" cannot be empty`);
			} else {
				this.isValid = true;
				this.$el.removeClass(this.clsError);
				this.hideError();
			}
		} else if ($el.hasClass('js-start-end-time')) {
			const $startDate = $el.find('[name="start_date"]');
			const $endDate = $el.find('[name="end_date"]');
			const $startTime = $el.find('[name="start_time"]');
			const $endtime = $el.find('[name="end_time"]');

			const $breach_start_time = $el.find('[name="breach_start_time"]');
			const $breach_end_time = $el.find('[name="breach_end_time"]');

			if (
				($startDate[0].value,
				$endDate[0].value,
				$startTime[0].value,
				$endtime[0].value)
			) {
				const startDateParts = $startDate[0].value.split('/');
				const endDateParts = $endDate[0].value.split('/');
				const startTimeParts = $startTime[0].value.split(':');
				const endTimeParts = $endtime[0].value.split(':');

				const start = new Date(
					+startDateParts[2],
					startDateParts[1] - 1,
					+startDateParts[0]
				);
				const end = new Date(
					+endDateParts[2],
					endDateParts[1] - 1,
					+endDateParts[0]
				);

				start.setHours(startTimeParts[0]);
				start.setMinutes(startTimeParts[1]);
				end.setHours(endTimeParts[0]);
				end.setMinutes(endTimeParts[1]);

				// set start/end ties as unix timestamps on hidden fields
				$breach_start_time.val(start.getTime() / 1000);
				$breach_end_time.val(end.getTime() / 1000);

				if (start >= end) {
					this.isValid = false;
					this.$el.addClass(this.clsError);
					this.$error.addClass(this.clsVisible);
					this.$error.text(`End time must later than start time`);
				} else {
					this.isValid = true;
					this.$el.removeClass(this.clsError);
					this.hideError();
				}
			}
		}

		// Regular field validation
		else {
			let v = validate.single(val, constraints);

			if (typeof v !== 'undefined') {
				this.showError(v);
				this.isValid = false;
			} else {
				this.hideError();
				this.isValid = true;
			}
		}
	}

	showError(v) {
		// Always get the first error response
		var error = validate.capitalize(v[0]);
		this.$el.addClass(this.clsError);
		this.$error.text(error);
		this.$error.addClass(this.clsVisible);
	}

	hideError() {
		this.$el.removeClass(this.clsError);
		this.$error.text('');
		this.$error.removeClass(this.clsVisible);
	}
}

export default Fields;
